import React from 'react'
import styled from 'styled-components'
import {FaMapMarkerAlt} from 'react-icons/fa'

// Constants
import {colors} from '~/constants/style'

// Components
import LatestBL from '../LatestBlogList/LatestBlogList.styled'

const RPs = styled.div`
  margin-bottom: 40px;
`

RPs.Title = styled(LatestBL.Title)`
  margin-bottom: 17px;
`

RPs.ItemsWrapper = styled.div``

RPs.Item = styled.div`
  display: flex;
  
  &:hover {
    text-decoration: none;
  }

  &:not(:last-child) {
    margin-bottom: 15px;
  }
`

RPs.ItemThumbnail = styled.div`
  flex: 70px 0 0;
  height: 70px;
  margin-right: 15px;
  display: flex;
  position: relative;
`

RPs.ItemRight = styled.div``

RPs.ItemTitle = styled.h2`
  font-weight: 600;
  color: black;
  font-size: 1rem;
`

RPs.ItemAddress = styled.div.attrs(
  ({address}) => ({
    children: (
      <>
        <FaMapMarkerAlt />

        {address}
      </>
    ),
  }),
)`
  color: #B8BCC6;
  margin-bottom: 3px;

  svg {
    color: ${colors.green};
    padding-right: 5px;
  }
`

RPs.ItemPrice = styled.div`
  color: ${colors.green};
  font-weight: 600;
`

export default RPs
